import { Injectable } from '@angular/core';

class OverlayContainerStackManager {
  public insert(containerNode: HTMLElement, pane: HTMLElement, level: number) {
    const layeredNodes = <HTMLElement[]>(
      Array.from(document.querySelectorAll(`[data-overlay-level]`)).reverse()
    );

    if (layeredNodes.length === 0) {
      containerNode.appendChild(pane);
    } else {
      const lastNode = layeredNodes.find(
        node => parseInt(node.dataset.overlayLevel!, 10) === level,
      );

      if (lastNode) {
        lastNode.after(pane);
      } else if (level === 0) {
        containerNode.prepend(pane);
      } else {
        containerNode.appendChild(pane);
      }
    }
  }
}

/**
 * The OverlayContainer is the container in which all overlays will load.
 * It should be provided in the root component to ensure it is properly shared.
 */
@Injectable({ providedIn: 'root' })
export class OverlayContainer {
  protected _stackManager = new OverlayContainerStackManager();
  protected _containerElement: HTMLElement;

  public insert(pane: HTMLElement, level: number) {
    this._stackManager.insert(this.getContainerElement(), pane, level);
  }

  /**
   * This method returns the overlay container element.  It will lazily
   * create the element the first time  it is called to facilitate using
   * the container in non-browser environments.
   * @returns the container element
   */
  public getContainerElement(): HTMLElement {
    if (!this._containerElement) {
      this._createContainer();
    }
    return this._containerElement;
  }

  /**
   * Create the overlay container element, which is simply a div
   * with the 'rt-overlay-container' class on the document body.
   */
  protected _createContainer(): void {
    const container = document.createElement('div');
    container.classList.add('rt-overlay-container');
    document.body.appendChild(container);
    this._containerElement = container;
  }
}
